<template>
  <div id="news-detail">
    <header-section :subnav_show="false" :change_color="true"></header-section>
    <!-- ======= Hero Section ======= -->
    <div id="hero-news" data-aos="zoom-out" data-aos-delay="100"></div>

    <div class="container">

      <div class="section-title">
        <h2>新闻动态</h2>
        <p>NEWS</p>
      </div>

      <el-row :gutter="15" class="margin-top-30">
        <el-col :span="18">
          <div class="content-list-items">
            <h2 class="text-align-center margin-top-30">{{ articleDetail.title }}</h2>
            <!-- <p class="item-date"><i class="el-icon-time"></i> {{ formatDate(articleDetail.publishDate) }}</p> -->
            <div class="item-content margin-top-30" v-html="articleDetail.content"></div>
          </div>

        </el-col>

        <el-col :span="6">
          <div class="right-sidebar">
            <h5 class="sidebar-title"><i class="el-icon-folder"></i> 新闻分类</h5>
            <div class="sidebar-item">
              <div>
                <div :class="queryParam.channelId == 111 ? 'active-link' : ''" style="cursor: pointer" @click="storenewsid(111)">
                  全部分类
                </div>
              </div>
              <div v-for="(v, k) in reSubChannelList" :key="k">
                <div :class="queryParam.channelId == v.id ? 'active-link' : ''" style="cursor: pointer" @click="storenewsid(v.id)">
                  <span>{{ v.channelName }}</span>
                </div>
              </div>
            </div>

            <h5 class="sidebar-title"><i class="el-icon-document"></i> 热点新闻</h5>
            <div class="sidebar-item">
              <div v-for="(v, k) in reTopList" :key="k">
                <a href="javascript:void(0)" @click="tonewsdetail(v.id)">
                  {{ v.title }}
                </a>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- footer -->
    <footer-section></footer-section>
  </div>
</template>
<script>
import store from '@/store'
import HeaderSection from "@/components/public/head.vue"
import FooterSection from "@/components/public/footer.vue"
export default {
  components: {
    HeaderSection,
    FooterSection
  },
  props: {},
  data() {
    return {
      queryParam: {
        channelId: this.$route.params.id,
        isShow: 1,
        page: 1,
        limit: 10
      },
      //当前栏目id
      currChannelId: 111,
      articleId: 0,
      articleDetail: {},

      reSubChannelList: [],
      reTopList: [],
    };
  },
  watch: {
  },
  computed: {
  },
  methods: {
    //动态修改浏览器标题
    setBrowserTitle(title) {
        document.title = title;
        },
        //动态添加meta标签 keywords content
        addMetaKeyWords (keywords) {
            let m = document.querySelectorAll('meta');
            for(let i=0;i<m.length;i++){
                if(m[i].content ==keywords){
                    m[i].remove()
                }
            }
            const meta = document.createElement('meta')
            meta.name = 'keywords'
            meta.content = keywords
            document.head.appendChild(meta)
            
        },
    getArticleDetail() {
      this.$get(this.$api.getArticleDetail + "/" + this.articleId).then(response => {
        if (response.code === 0) {
          this.articleDetail = response.data;
          this.setBrowserTitle(response.data.title)
          this.addMetaKeyWords(response.data.title)
          this.loading = false
        } else {
          window.console.log(response.msg);
        }
      });
    },
    getSubChannelList() {
      this.$get(this.$api.getSubChannelList + '/' + this.currChannelId).then(res => {
        if (res.code === 0) {
          this.reSubChannelList = res.data;
          this.loading = false
        } else {
          window.console.log(res.msg);
        }
      });
    },
    getArticleTopList() {
      this.$get(this.$api.getArticleTopList + '/' + this.currChannelId).then(res => {
        if (res.code === 0) {
          this.reTopList = res.data;
          this.loading = false
        } else {
          window.console.log(res.msg);
        }
      });
    },
    // yyyy-MM-dd HH:mm:ss
    formatDate(value) { // 时间戳转换日期格式方法
      if (value == null) {
        return ''
      } else {
        const date = new Date(value)
        const y = date.getFullYear()// 年
        let MM = date.getMonth() + 1 // 月
        MM = MM < 10 ? ('0' + MM) : MM
        let d = date.getDate() // 日
        d = d < 10 ? ('0' + d) : d
        return y + '-' + MM + '-' + d
      }
    },
    // 存储选择的新闻类别id
    storenewsid(id){
      store.commit('set_temp_id', id)
      this.$router.push('/news')
    },
    tonewsdetail(id){
      this.$router.push('/news/detail/'+id)
      this.articleId = id
      this.getArticleDetail();
      this.getSubChannelList();
      this.getArticleTopList();
    }
  },

  created() {
    this.articleId = this.$route.params.id;
    if (this.$isEmpty(this.articleId)) {
      return this.$message.error('请检查信息是否存在');
    }
    this.getArticleDetail();
    this.getSubChannelList();
    this.getArticleTopList();
  },
  mounted() {
  },
  destroyed(){
    document.title='河北科瑞达仪器科技股份有限公司-官方网站'
  }
};
</script>
<style scoped>
/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/
#hero-news {
  width: 100%;
  height: 45vh;
  background: url("~@/static/img/banner/news-banner.jpg");
  background-size: cover;
  position: relative;
}

/* .plat_tab {
    width: 100%;
    height: 60px;
    background: #f0f2f5
} */
.media-body .h4 {
  font-weight: 700;
  margin-bottom: 5px;
  font-size: 16px;
  color: #37517e;
}

.blue {
  color: #37517e;
}

.content-list-items /deep/ img{
  max-width: 100%;
  height: auto
}

.sidebar {
  padding: 30px;
  /*margin: 0 0 60px 20px;*/
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  background: #fff;
}

/* @media (max-width: 768px) {
    .nap-container {
        width: 100%;
        padding: 0 16px
    }
}

@media (min-width: 768px) and (max-width: 991px) {
    .nap-container {
        width: 100%;
        padding: 0 64px
    }
}

@media (min-width: 991px) and (max-width: 1540px) {
    .nap-container {
        width: 100%;
        padding: 0 130px
    }
}

@media (min-width: 1541px) {
    .nap-container {
        width: 1280px;
        margin: 0 auto
    }
} */

/* @media (min-width: 1200px) and (max-width: 1340px) {
    .plat_title {
        font-size: 40px;
        top: 180px
    }
}

@media (min-width: 992px) and (max-width: 1199px) {
    .plat_title {
        font-size: 34px;
        top: 156px
    }
}

@media (min-width: 768px) and (max-width: 991px) {
    .plat_title {
        font-size: 28px;
        top: 136px
    }
}

@media (max-width: 767px) {
    .plat_title {
        display: none
    }
    .plat_title_m {
        display: block;
        position: absolute;
        padding-left: 42px;
        font-size: 16px;
        line-height: 28px;
        font-weight: 600;
        color: #fff;
        top: 86px
    }
    .plat_tab {
        height: 44px
    }
    .plat_tab_text {
        margin-right: 24px;
        line-height: 41px;
        font-size: 14px;
        color: #666;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
    }
} */
</style>